import React, { useState, useEffect } from "react";
import { ref, set, onValue, remove } from "firebase/database";
import { db } from "../firebase";
import Swal from "sweetalert2";
import "./SimpleAdmin.css";

const SimpleAdmin = () => {
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [selectedGovernorate, setSelectedGovernorate] = useState("");
  const [price, setPrice] = useState("");
  const [currentPrices, setCurrentPrices] = useState([]);
  const [loading, setLoading] = useState(false);

  const ADMIN_PASSWORD = "poultry456";

  // المحافظات الأساسية
  const governoratesList = [
    "سامراء",
    "ميسان",
    "النجف",
    "كربلاء",
    "السماوة",
    "الموصل",
    "ديالى",
    "الناصرية",
    "البصرة",
    "الديوانية",
    "الانبار",
    "بابل",
    "واسط",
    "بغداد",
    "صلاح الدين",
    "كركوك",
    "المناطق الجنوبية",
    "المناطق الشمالية",
    "الاقليم",
  ];

  useEffect(() => {
    if (isAuthenticated) {
      loadPricesFromFirebase();
    }
  }, [isAuthenticated]);

  const loadPricesFromFirebase = () => {
    setLoading(true);
    const pricesRef = ref(db, "prices");

    const unsubscribe = onValue(pricesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const pricesArray = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setCurrentPrices(pricesArray);
      } else {
        setCurrentPrices([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      await Swal.fire({
        icon: "success",
        title: "مرحباً!",
        text: "تم الدخول بنجاح إلى لوحة التحكم",
        confirmButtonText: "متابعة",
      });
    } else {
      await Swal.fire({
        icon: "error",
        title: "خطأ",
        text: "كلمة المرور غير صحيحة",
        confirmButtonText: "حاول مرة أخرى",
      });
    }
  };

  const handleUpdatePrice = async (e) => {
    e.preventDefault();

    if (!selectedGovernorate || !price) {
      await Swal.fire({
        icon: "warning",
        title: "بيانات ناقصة",
        text: "يرجى اختيار المحافظة وإدخال السعر",
        confirmButtonText: "حسناً",
      });
      return;
    }

    try {
      setLoading(true);

      // حفظ السعر في Firebase باستخدام اسم المحافظة كمفتاح
      const priceRef = ref(db, `prices/${selectedGovernorate}`);

      await set(priceRef, {
        governorate: selectedGovernorate,
        price: price,
        timestamp: new Date().toISOString(),
      });

      await Swal.fire({
        icon: "success",
        title: "تم التحديث!",
        html: `
          <div style="text-align: center;">
            <h4>${selectedGovernorate}</h4>
            <p style="font-size: 1.2rem; color: #059669; font-weight: bold;">
              ${price} دينار
            </p>
            <p>تم تحديث السعر للجميع</p>
          </div>
        `,
        confirmButtonText: "تم",
      });

      setSelectedGovernorate("");
      setPrice("");
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "خطأ",
        text: "حدث خطأ أثناء حفظ البيانات في السيرفر",
        confirmButtonText: "حسناً",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateAll = async () => {
    await Swal.fire({
      icon: "info",
      title: "تم التحديث",
      text: "جميع الأسعار محدثة ومتاحة للجميع",
      confirmButtonText: "ممتاز",
    });
  };

  const handleBackToHome = () => {
    window.location.href = "/";
  };

  const handleDeletePrice = async (governorate) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "تأكيد الحذف",
      html: `هل أنت متأكد من حذف سعر <strong>${governorate}</strong>؟`,
      showCancelButton: true,
      confirmButtonText: "نعم، احذف",
      cancelButtonText: "إلغاء",
      confirmButtonColor: "#ef4444",
    });

    if (result.isConfirmed) {
      try {
        const priceRef = ref(db, `prices/${governorate}`);
        await remove(priceRef);

        await Swal.fire({
          icon: "success",
          title: "تم الحذف",
          text: `تم حذف سعر ${governorate}`,
          confirmButtonText: "تم",
        });
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء الحذف",
          confirmButtonText: "حسناً",
        });
      }
    }
  };

  const getCurrentPrice = (governorate) => {
    const priceItem = currentPrices.find(
      (item) => item.governorate === governorate
    );
    return priceItem ? `${priceItem.price} دينار` : "غير محدد";
  };

  if (!isAuthenticated) {
    return (
      <div className="simple-admin-login">
        <div className="login-box">
          <div className="login-header">
            <h2> 🔐دخول المدير </h2>{" "}
            <p> أدخل كلمة المرور للوصول إلى لوحة التحكم </p>{" "}
          </div>{" "}
          <form onSubmit={handleLogin} className="login-form">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="كلمة المرور"
              className="password-input"
              required
            />
            <button type="submit" className="login-btn">
              دخول{" "}
            </button>{" "}
          </form>{" "}
        </div>{" "}
      </div>
    );
  }

  return (
    <div className="simple-admin">
      <div className="admin-header">
        <h1> 🛠️إدارة أسعار الدجاج </h1>{" "}
        <div className="header-actions">
          <button
            onClick={handleUpdateAll}
            className="update-btn"
            disabled={loading}
          >
            {loading ? "⏳ جاري التحديث..." : "🔄 تحديث الأسعار"}{" "}
          </button>{" "}
          <button onClick={handleBackToHome} className="home-btn">
            {" "}
            🏠الرئيسية{" "}
          </button>{" "}
        </div>{" "}
      </div>
      <div className="admin-content">
        {" "}
        {/* نموذج تحديث السعر */}{" "}
        <div className="update-form-section">
          <h3> تحديث سعر المحافظة </h3>{" "}
          <form onSubmit={handleUpdatePrice} className="update-form">
            <div className="form-group">
              <label> اختر المحافظة: </label>{" "}
              <select
                value={selectedGovernorate}
                onChange={(e) => setSelectedGovernorate(e.target.value)}
                className="gov-select"
                required
                disabled={loading}
              >
                <option value=""> --اختر المحافظة-- </option>{" "}
                {governoratesList.map((gov) => (
                  <option key={gov} value={gov}>
                    {" "}
                    {gov} - {getCurrentPrice(gov)}{" "}
                  </option>
                ))}{" "}
              </select>{" "}
            </div>
            <div className="form-group">
              <label> السعر الجديد(دينار): </label>{" "}
              <input
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="أدخل السعر الجديد"
                className="price-input"
                required
                disabled={loading}
              />{" "}
            </div>
            <button
              type="submit"
              className="update-price-btn"
              disabled={loading}
            >
              {loading ? "⏳ جاري الحفظ..." : "💰 تحديث السعر"}{" "}
            </button>{" "}
          </form>{" "}
        </div>
        {/* قائمة الأسعار الحالية */}{" "}
        <div className="current-prices">
          <h3> الأسعار الحالية({currentPrices.length}) </h3>{" "}
          {loading ? (
            <div className="loading"> جاري تحميل البيانات... </div>
          ) : (
            <div className="prices-grid">
              {" "}
              {currentPrices.map((item) => (
                <div key={item.id} className="price-item">
                  <div className="price-info">
                    <div className="gov-name"> {item.governorate} </div>{" "}
                    <div className="price-value">
                      {" "}
                      {item.price}
                      دينار{" "}
                    </div>{" "}
                    <div className="update-time">
                      {" "}
                      {new Date(item.timestamp).toLocaleDateString(
                        "ar-EG"
                      )}{" "}
                    </div>{" "}
                  </div>{" "}
                  <button
                    onClick={() => handleDeletePrice(item.governorate)}
                    className="delete-btn"
                    title="حذف السعر"
                    disabled={loading}
                  >
                    🗑️
                  </button>{" "}
                </div>
              ))}{" "}
            </div>
          )}{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};

export default SimpleAdmin;
